module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAAAMgAAADIAGP6560AAAAHdElNRQfkBBQDFifQLivZAAAAEGNhTnYAAAAgAAAAIAAAAAAAAAAAYrnu+gAAAFBJREFUKM+d0VkOABAMBNC5/6UHIaqZsUR9iPRpLUAO1mGjJ9gCVDYTfR6rB0AhCaQ6BkSj5YARAVJ/Cps7sUlDiyvYkgswT3UC5prmw75AAXSXLOLk/iyoAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTA0LTIwVDAzOjIyOjM4KzAwOjAwbfu3YQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0wNC0yMFQwMzoyMjozOCswMDowMBymD90AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/icons/openhand.png
// module id = BrYH
// module chunks = 18